jQuery(document).ready(function ($) {
    var $infograficos = $('.home-infograficos .swiper-container');

    if (!$infograficos.length) return

    var mySwiper = new Swiper($infograficos, {
        slidesPerView: 1,
        navigation: {
            prevEl: $infograficos.parent().find('.carousel-navigation span.prev'),
            nextEl: $infograficos.parent().find('.carousel-navigation span.next'),
        },
        pagination: {
            el: '.infograficos-navigation',
            clickable: true,
            bulletClass: 'bullet',
            bulletActiveClass: 'bullet-active',
            modifierClass: 'testimony-pagination-'
        }
    });
});